<script lang="ts">
  import { t } from '../i18n/index';

  let {
    onSubmit,
    pending = false,
    errorMessage = '',
  }: {
    onSubmit: (payload: { name: string; email: string | null }) => void;
    pending?: boolean;
    errorMessage?: string;
  } = $props();

  let name = $state('');
  let email = $state('');
  let skipEmail = $state(false);
  let localError = $state(null as string | null);

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function handleSubmit(event: SubmitEvent) {
    event.preventDefault();
    localError = null;
    const trimmedName = name.trim();
    if (!trimmedName) {
      localError = t('visitor.nameRequired');
      return;
    }
    let emailValue: string | null = null;
    if (!skipEmail) {
      const trimmedEmail = email.trim();
      if (trimmedEmail) {
        if (!EMAIL_RE.test(trimmedEmail)) {
          localError = t('visitor.invalidEmail');
          return;
        }
        emailValue = trimmedEmail;
      }
    }
    onSubmit({ name: trimmedName, email: emailValue });
  }
</script>

<form
  class="tashimoto-support-flex tashimoto-support-flex-col tashimoto-support-gap-3 tashimoto-support-p-4 tashimoto-support-bg-white"
  data-testid="visitor-form"
  onsubmit={handleSubmit}
>
  <div>
    <h3 class="tashimoto-support-text-lg tashimoto-support-font-semibold tashimoto-support-text-gray-900">
      {t('visitor.welcome')}
    </h3>
    <p class="tashimoto-support-text-sm tashimoto-support-text-gray-500 tashimoto-support-mt-1">
      {t('visitor.introLine')}
    </p>
  </div>

  <label class="tashimoto-support-flex tashimoto-support-flex-col tashimoto-support-gap-1">
    <span class="tashimoto-support-text-xs tashimoto-support-font-medium tashimoto-support-text-gray-700">
      {t('editProfile.nameLabel')}
    </span>
    <input
      type="text"
      required
      bind:value={name}
      placeholder={t('visitor.namePlaceholder')}
      class="tashimoto-support-border tashimoto-support-rounded-lg tashimoto-support-px-3 tashimoto-support-py-2 tashimoto-support-text-sm focus:tashimoto-support-outline-none focus:tashimoto-support-ring-2 focus:tashimoto-support-ring-blue-500"
      data-testid="visitor-form-name"
    />
  </label>

  {#if !skipEmail}
    <label class="tashimoto-support-flex tashimoto-support-flex-col tashimoto-support-gap-1">
      <span class="tashimoto-support-text-xs tashimoto-support-font-medium tashimoto-support-text-gray-700">
        {t('editProfile.emailLabel')}
      </span>
      <input
        type="email"
        bind:value={email}
        placeholder={t('visitor.emailPlaceholder')}
        class="tashimoto-support-border tashimoto-support-rounded-lg tashimoto-support-px-3 tashimoto-support-py-2 tashimoto-support-text-sm focus:tashimoto-support-outline-none focus:tashimoto-support-ring-2 focus:tashimoto-support-ring-blue-500"
        data-testid="visitor-form-email"
      />
    </label>
  {/if}

  <button
    type="button"
    class="tashimoto-support-text-xs tashimoto-support-text-blue-600 hover:tashimoto-support-underline tashimoto-support-self-start"
    onclick={() => {
      skipEmail = !skipEmail;
      if (skipEmail) email = '';
    }}
    data-testid="visitor-form-skip-email"
  >
    {skipEmail ? t('editProfile.emailLabel') : t('visitor.skipEmail')}
  </button>

  {#if localError || errorMessage}
    <p
      class="tashimoto-support-text-sm tashimoto-support-text-red-600"
      data-testid="visitor-form-error"
      role="alert"
    >
      {localError ?? errorMessage}
    </p>
  {/if}

  <button
    type="submit"
    disabled={pending}
    class="tashimoto-support-bg-blue-500 hover:tashimoto-support-bg-blue-600 disabled:tashimoto-support-bg-blue-300 tashimoto-support-text-white tashimoto-support-font-medium tashimoto-support-rounded-lg tashimoto-support-py-2.5 tashimoto-support-transition-colors"
    data-testid="visitor-form-submit"
  >
    {t('visitor.start')}
  </button>
</form>
